export enum WorkflowQuestionType {
  Radio = 'RADIO',
  Checkbox = 'CHECKBOX',
  Text = 'TEXT',
  Counter = 'COUNTER',
  Time = 'TIME',
  Media = 'MEDIA',
  Routine = 'ROUTINE',
  Label = 'LABEL',
  Signature = 'SIGNATURE',
  Status = 'STATUS',
  QuickConfirm = 'QUICK_CONFIRM',
}
